<template>
  <div>
    <div class="header-page-surveys detail" @click="hideSurveyDetail()">
        <span class="icon_arrow"></span>
        {{surveyItem.title}}
    </div>
    <div class="survey-detail-component">
      <div v-for="(item, index) in surveyItem.questionnaire_items" class="survey-selection" :key="index">
          <div class="title-survey-item">
              <span>{{index + 1}}. </span>{{item.body}}
          </div>
          <div v-if="item.format === 0">
            <textarea v-model="tempAnswerContents[index].content" @change="changeAnswer(item, index)" class=" text-area-survey-answer w100 border-radius-4 p-1" rows="5"></textarea>
          </div>
          <div v-if="item.format === 1" class="answers-survey">
              <el-select v-model="tempAnswerContents[index].content" @change="changeAnswer(item, index)" class="survey-answers" placeholder="回答を選択する">
                <el-option
                  v-for="(select, index2) in item.questionnaire_selections"
                  :key="index2"
                  :label="select.title"
                  :value="select.title">
                </el-option>
              </el-select>
          </div>
          <div v-if="item.format === 2" class="answers-survey">
            <el-checkbox-group size="medium" v-model="tempAnswerContents[index].questionnaire_selections" @change="changeAnswer(item, index)">
              <div v-for="(select, index2) in item.questionnaire_selections" :key="index2">
                <el-checkbox size="medium" :label="select.title"></el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          
      </div>
      <div class="survey-detail-buttons" v-if="!surveyItem.is_complete">
        <span class="cancel-survey" @click="hideSurveyDetail()">キャンセル</span>
        <span class="submit-survey" @click="submitSurvey()">送信</span>
      </div>
    </div>    
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import SurveyApi from '@/api/questionnaire'
import _ from 'lodash'

export default {
  props: {
    surveyItem: {type: Object, default: {}},
    totalSurveys: {type: Number, default: 0}
  },
  data () {
    return {
      data: {
        answers: []
      },
      tempAnswerContents: [],
      options: [{
        value: '1',
        label: '1'
      }],
      value: 0,
      test: []
    }
  },
  computed: {
    ...mapGetters({
      surveys: 'surveys/surveys'
    })
  },
  methods: {
    ...mapActions({
      deleteSurvey: 'surveys/deleteSurvey',
      setIsShowSurveysModal: 'surveys/setIsShowSurveysModal',
      completeSurvey: 'masterData/completeSurvey'
    }),
    async submitSurvey () {
      const loading = this.$loading.show()
      try {
        this.data.employee_code = this.$auth.user().employee_code
        this.data.company_code = this.$auth.user().company_code
        this.data.questionnaire_id = this.surveyItem.id
        const index = _.findIndex(this.tempAnswerContents, n => {
          if (n.format === 2) return !n.questionnaire_selections.length
          else return n.content === ''
        })
        if (index !== -1) {
          loading.hide()
          return this.$message({message: '全ての質問を回答してください !', type: 'error'})
        }

        this.tempAnswerContents.forEach(n => {
          if (n.format === 2) {
            n.questionnaire_selections.map(selection => {
              this.data.answers.push({
                content: selection,
                questionnaire_item_id: n.questionnaire_item_id
              })
            })
          } else {
            if (n.content && n.content !== '') {
              this.data.answers.push({
                content: n.content,
                questionnaire_item_id: n.questionnaire_item_id
              })
            }
          }
        })
        const response = await SurveyApi.submit(this.data)
        this.deleteSurvey(response.data.data)
        this.$message({message: 'アンケートの回答を送信しました !', type: 'success'})
        this.completeSurvey()
        loading.hide()
        this.hideSurveyDetail()
        const surveyNotCompleteIndex = this.surveys.findIndex(n => n.is_complete === false)
        if (surveyNotCompleteIndex === -1) {
          this.setIsShowSurveysModal(false)
        }
      } catch (e) {
        loading.hide()
        this.$message({message: e, type: 'error'})
      }
    },
    changeAnswer (surveyItem, index) {
      this.tempAnswerContents[index].questionnaire_item_id = surveyItem.id
    },
    hideSurveyDetail () {
      this.$emit('hideSurveyDetail')
    },
    setDataSurveyItemsModel () {
      for (let i = 0; i < this.surveyItem.questionnaire_items.length; i++) {
        let data = {
          content: this.surveyItem.questionnaire_items[i].answer,
          format: this.surveyItem.questionnaire_items[i].format,
          questionnaire_item_id: null,
          questionnaire_selections: this.surveyItem.questionnaire_items[i].answer
        }
        this.tempAnswerContents.push(data)
      }
    }
  },
  beforeMount () {
    this.setDataSurveyItemsModel()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/survey-detail.vue